import script from "./UserFollowing.vue?vue&type=script&setup=true&lang=js"
export * from "./UserFollowing.vue?vue&type=script&setup=true&lang=js"

import "./UserFollowing.vue?vue&type=style&index=0&id=21b6911d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b6911d"]])

export default __exports__